module.exports = __webpack_public_path__ + "static/media/google-play.88bdabd1.png";